import React, { useState,useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';


const SeleccionCodigoRazaDash = (props) => {
  const [selectedAutoValue, setSelectedAutoValue] = useState(props.RAZA_MACHO);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState([]);
  const [reload, setReload] = useState(true)
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => {
    if(props.COD_ESPECIE==undefined) return;
    async function traerUsuarios(COD_ESPECIE,NID_PROPIETARIO) {
      const data = new FormData();
      data.append('COD_ESPECIE',COD_ESPECIE)
      data.append('NID_PROPIETARIO',NID_PROPIETARIO)
      await fetch(APITABLASBASICAS + 'seleccionCodigoRazasDash', {
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            setReload(false)
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
        traerUsuarios(props.COD_ESPECIE,props.NID_PROPIETARIO)
  }, [reload,props.COD_ESPECIE,props.NID_PROPIETARIO]);


  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};




  const handleChange = (event) => {
    setSelectedAutoValue(event)
    return props.handleplanta(event.code,4,false)
  };


  return (
    <div className="p-error">
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" />
    </div>
  );
};

export default SeleccionCodigoRazaDash;
